/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CityResponseDto
 */
export interface CityResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CityResponseDto
     */
    postalCodes: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CityResponseDto
     */
    population?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CityResponseDto
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CityResponseDto
     */
    longitude?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    departmentCode: string;
    /**
     * 
     * @type {string}
     * @memberof CityResponseDto
     */
    provinceCode: string;
    /**
     * 
     * @type {Date}
     * @memberof CityResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CityResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CityResponseDto interface.
 */
export function instanceOfCityResponseDto(value: object): value is CityResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('postalCodes' in value) || value['postalCodes'] === undefined) return false;
    if (!('departmentCode' in value) || value['departmentCode'] === undefined) return false;
    if (!('provinceCode' in value) || value['provinceCode'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CityResponseDtoFromJSON(json: any): CityResponseDto {
    return CityResponseDtoFromJSONTyped(json, false);
}

export function CityResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CityResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'postalCodes': json['postalCodes'],
        'population': json['population'] == null ? undefined : json['population'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'departmentCode': json['departmentCode'],
        'provinceCode': json['provinceCode'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function CityResponseDtoToJSON(json: any): CityResponseDto {
    return CityResponseDtoToJSONTyped(json, false);
}

export function CityResponseDtoToJSONTyped(value?: CityResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'postalCodes': value['postalCodes'],
        'population': value['population'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'departmentCode': value['departmentCode'],
        'provinceCode': value['provinceCode'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

